export default {
  id: '',
  theme: 'system',
  file: '',
  caption: '',
  lines: '',
  linesExpanded: false,
  highlightLines: '',
  showFooter: true,
  showLineNumbers: true,
  enableCache: true,

  onInit: null, // () => {}
  onInitEnd: null, // () => {}
  onDestroy: null, // () => {}
  onDestroyEnd: null, // () => {}
  onAjaxBeforeSend: null, // () => {}
  onAjaxSuccess: null, // (response) => {}
  onAjaxLoaded: null, // () => {}
};
